<template>
    <v-menu v-if="timePeriodSelected != -1" open-on-hover close-on-click close-on-content-click offset-y rounded style="z-index: 999">
        <template v-slot:activator="{ on, attrs }">
            <v-btn text small color="primary" v-bind="attrs" v-on="on">
                <v-icon left>mdi-history</v-icon>{{ timePeriodSelections[timePeriodSelected].title }}
            </v-btn>
        </template> 
        <v-list>
            <v-list-item-group v-model="timePeriodSelected">
                <v-list-item v-for="(item, index) in timePeriodSelections" :key="index">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list-item-group>            
        </v-list>
    </v-menu>          
</template>

<script>
    import Constants from '@/config/constants'

    export default {
        name: 'TimePeriodSelection',
        props: ['buttonText', 'defaultSelection'],        
        mounted: function () {
            switch (this.$options.propsData.defaultSelection) {
                case Constants.LAST_5_MIN:
                    console.log("Last 5 minutes selected")
                    this.timePeriodSelected = 0;
                    break;
                case Constants.LAST_60_MIN:
                    console.log("Last 60 minutes selected")
                    this.timePeriodSelected = 1;
                    break;
                case Constants.LAST_3_HOURS:
                    console.log("Last 3 hours selected")
                    this.timePeriodSelected = 2;
                    break;
                case Constants.LAST_6_HOURS:
                    console.log("Last 6 hours selected")
                    this.timePeriodSelected = 3;
                    break;
                case Constants.LAST_12_HOURS:
                    console.log("Last 12 hours selected")
                    this.timePeriodSelected = 4;
                    break;
                case Constants.LAST_24_HOURS:
                    console.log("Last 24 hours selected")
                    this.timePeriodSelected = 5;
                    break;
                case Constants.LAST_3_DAYS:
                    console.log("Last 3 days selected")
                    this.timePeriodSelected = 6;
                    break;
                case Constants.LAST_7_DAYS:
                    console.log("Last 7 days selected")
                    this.timePeriodSelected = 7;
                    break;
                case Constants.LAST_14_DAYS:
                    console.log("Last 14 days selected")
                    this.timePeriodSelected = 8;
                    break;
                case Constants.LAST_30_DAYS:
                    console.log("Last 30 days selected")
                    this.timePeriodSelected = 9;
                    break;
                default:
                    break;
            }
        },
        computed: {
        },
        watch: {
            timePeriodSelected: function(newValue, oldValue) {
                if (typeof newValue !== 'undefined') {
                    const numOfMinutesAgo = this.timePeriodSelections[newValue].value
                    if (oldValue != -1) { // Suppress 'emit' during initialization
                        this.$emit('onTimePeriodSelected', numOfMinutesAgo)
                    }
                } else {
                    this.timePeriodSelected = oldValue
                }
            }
        },        
        methods: {
        },
        data: function() {
            return {
                timePeriodSelections: [
                    { title: this.buttonText + ' 5 minutes', value: Constants.LAST_5_MIN },
                    { title: this.buttonText + ' 60 minutes', value: Constants.LAST_60_MIN },
                    { title: this.buttonText + ' 3 hours', value: Constants.LAST_3_HOURS },
                    { title: this.buttonText + ' 6 hours', value: Constants.LAST_6_HOURS },
                    { title: this.buttonText + ' 12 hours', value: Constants.LAST_12_HOURS },
                    { title: this.buttonText + ' 24 hours', value: Constants.LAST_24_HOURS },
                    { title: this.buttonText + ' 3 days', value: Constants.LAST_3_DAYS},
                    { title: this.buttonText + ' 7 days', value: Constants.LAST_7_DAYS },
                    { title: this.buttonText + ' 14 days', value: Constants.LAST_14_DAYS },
                    { title: this.buttonText + ' 30 days', value: Constants.LAST_30_DAYS }
                ],
                timePeriodSelected: -1
            }
        },
    }

</script>

<style scoped lang="scss">

</style>
